import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../commonComponents/translate';
import GameEventProp from '../propTypes/gameEventProp';
import TimelineItemContainer from '../../../commonComponents/timeline/TimelineItemContainer';
import {
  displayUserName,
  GAME_EVENT_TYPE,
} from '../../../services/utilityFunctions';
import TimelineItemFooter from '../details/timeline/TimelineItemFooter';

function LeadTimelineItem({
  t,
  side,
  isFirst,
  event,
  onAddLike,
  onAddComment,
}) {
  const date = moment.utc(event.date).format('DD MMM, YY - HH:mm');

  const message = (() => {
    switch (event.type) {
      case GAME_EVENT_TYPE.LEAD_CREATED:
        return event.user2
          ? t(
              'leadDetails_eventDescription_lead_created',
              displayUserName(event.user1, true),
              displayUserName(event.user2, true),
            )
          : t(
              'leadDetails_eventDescription_lead_created_noOwner',
              displayUserName(event.user1, true),
            );
      case GAME_EVENT_TYPE.LEAD_ATTACH_OWNER:
      case GAME_EVENT_TYPE.LEAD_CHANGED_OWNER:
        return t(
          `leadDetails_eventDescription_${event.type}`,
          displayUserName(event.user1, true),
        );
      case GAME_EVENT_TYPE.LEAD_CHANGED:
        return t(
          'leadDetails_eventDescription_lead_changed',
          t(`challengeDetails_leadCondition_${event.leadCondition}`),
        );
      case GAME_EVENT_TYPE.LEAD_NO_OWNER:
      case GAME_EVENT_TYPE.LEAD_LOST:
      case GAME_EVENT_TYPE.LEAD_WON:
      default:
        return t(`leadDetails_eventDescription_${event.type}`);
    }
  })();

  const showUserInfo =
    event.user1 &&
    (event.type === GAME_EVENT_TYPE.LEAD_CREATED ||
      event.type === GAME_EVENT_TYPE.LEAD_ATTACH_OWNER ||
      event.type === GAME_EVENT_TYPE.LEAD_CHANGED_OWNER);

  const title = t(`leadDetails_eventTitle_${event.type}`);

  return (
    <TimelineItemContainer
      side={side}
      isFirst={isFirst}
      title={title}
      date={date}
      footer={
        <TimelineItemFooter
          event={event}
          onCommentClick={onAddComment}
          onLikeClick={onAddLike}
        />
      }
    >
      {showUserInfo && (
        <div className="timeline-user-display">
          <img
            className="timeline-user-avatar"
            src={
              event.user1.image
                ? event.user1.image.thumb
                : '/images/no_user.png'
            }
            alt="user avatar"
          />
          {displayUserName(event.user1, true)}
        </div>
      )}
      <p style={showUserInfo ? { marginTop: '1rem' } : {}}>
        {event.info || message}
      </p>
    </TimelineItemContainer>
  );
}

LeadTimelineItem.propTypes = {
  t: PropTypes.func.isRequired,
  event: PropTypes.shape(GameEventProp.propType).isRequired,
  side: PropTypes.oneOf(['left', 'right']).isRequired,
  isFirst: PropTypes.bool.isRequired,
  onAddLike: PropTypes.func.isRequired,
  onAddComment: PropTypes.func.isRequired,
};

export default translate(LeadTimelineItem);
